import React, {Component} from "react"
import {getCategories} from "../../services/Api"
import "../SideBar.scss"
// import {ListGroup} from "react-bootstrap";
// import QuestionsFeed from "../feed/questions";
import {v4 as uuidv4} from "uuid";

class ContentBar extends Component {
    constructor() {
        super()
        this.state = {
            questions: [],
            categories: [],
        }
    }

    async componentDidMount() {
        const categories = await getCategories()

        console.log(categories)

        this.setState({
            ...this.state,
            categories: categories,
        })
    }

    render() {
        return (
            <React.Fragment>
                <div>
                    <div className='sidebar w3-light-grey sideBarWidth '>
                        {/*<div className='middleSection' id="sidebar-improve-your-feed">*/}
                        {/*    <ListGroup>*/}
                        {/*        <ListGroup.Item className='listFirstItem feedCateGoryName'>*/}
                        {/*            Improve Your feed{" "}*/}
                        {/*        </ListGroup.Item>*/}
                        {/*        <QuestionsFeed/>*/}
                        {/*    </ListGroup>*/}
                        {/*</div>*/}
                        {/* <h3 className="w3-bar-item">Menu</h3> */}
                        {/* <div className="menuIcon"> */}
                        {/* <img  className="menuIcon" src={require('../icons/menu-outlined.svg')}></img> */}
                        {/* </div> */}
                        <div className='contentHeaders'> By Content Type</div>

                        <div
                            // onClick={() => this.props.LoadQuestion("questions")}
                            className='SidebarIconText'
                        >
                            <div>
                                <img
                                    className='sideBarIcon'
                                    src={require("../../icons/home-filled.svg")}
                                    alt="home filled svg"/>
                            </div>
                            <div>
                                <div className='w3-bar-item  sideBarText '>
                                    All Questions
                                </div>
                            </div>
                        </div>
                        <div
                            // onClick={() => this.props.LoadQuestion("questions")}
                            className='SidebarIconText'
                        >
                            <div>
                                <img
                                    className='sideBarIcon'
                                    src={require("../../icons/home-filled.svg")}
                                    alt="home filled svg"/>
                            </div>
                            <div>
                                <div className='w3-bar-item  sideBarText '>
                                    Questions Answered
                                </div>
                            </div>
                        </div>

                        <div className='contentHeaders'> By Categories</div>
                        {this.state.categories.map((item) => (
                            <div key={uuidv4()}
                                // onClick={() =>
                                //     this.props.LoadQuestion(item.questions)
                                // }
                                className='SidebarIconText'
                            >
                                <div>
                                    <img
                                        className='sideBarIcon'
                                        src={require("../../icons/home-filled.svg")}
                                        alt="home filled svg"/>
                                </div>
                                <div>
                                    <div className='w3-bar-item  sideBarText '>
                                        {item.categoryName}
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className='contentHeaders'> Sort Order</div>

                        <div
                            // onClick={() => this.props.LoadQuestion("questions")}
                            className='SidebarIconText'
                        >
                            <div>
                                <img
                                    className='sideBarIcon'
                                    src={require("../../icons/home-filled.svg")}
                                    alt="home filled svg"/>
                            </div>
                            <div>
                                <div className='w3-bar-item  sideBarText '>
                                    Newest First
                                </div>
                            </div>
                        </div>
                        <div
                            // onClick={() => this.props.LoadQuestion("questions")}
                            className='SidebarIconText'
                        >
                            <div>
                                <img
                                    className='sideBarIcon'
                                    src={require("../../icons/home-filled.svg")}
                                    alt="home filled svg"/>
                            </div>
                            <div>
                                <div className='w3-bar-item  sideBarText '>
                                    Oldest First
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default ContentBar
